import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/providers/api.service';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { NavigationService } from 'src/app/providers/navigation.service';
import { CustomConfirmDialogComponent } from 'src/app/shared/components/custom-confirm-dialog/custom-confirm-dialog.component';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';

@Component({
  selector: 'sm-employees-profile',
  templateUrl: './employees-profile.component.html',
  styleUrls: ['./employees-profile.component.scss']
})
export class EmployeesProfileComponent implements OnInit {
  isloader:boolean = false
  apisub:Subscription
  selectedValue:number = 1
  employerData: any  = []
  joiningInvitationsList: any  = []
  constructor(private navservice: NavigationService, private apiservice: ApiService, private ls: LoaderServiceService, private router: Router, private dialog: MatDialog) {
    this.navservice.hideSidebarAndNav = false
    this.apisub = this.apiservice.apiResult.subscribe(resdata => {
      if(resdata.responseType === SM_CONSTANTS.RESULT_API_GET_EMPLOYER_LIST){
        this.employerData = []
        this.joiningInvitationsList = []
        if(resdata.result){
          if(this.selectedValue == 1){
            if(resdata.result.data.currentEmployers && resdata.result.data.currentEmployers.length > 0){
              this.employerData = resdata.result.data.currentEmployers
              this.employerData.forEach((element:any) => {
                element.entityInfo = typeof element.entityInfo == 'string' ? JSON.parse(element.entityInfo) : element.entityInfo 
                element.entity_services = typeof element.entity_services == 'string' ? JSON.parse(element.entity_services) : element.entity_services 
                element.entityInfo.default_image = typeof element.entityInfo.default_image == 'string' ? JSON.parse(element.entityInfo.default_image) : element.entityInfo.default_image 
              });
            }
          }
          else if(this.selectedValue == 2){
            if(resdata.result.data.previousEmployers && resdata.result.data.previousEmployers.length > 0){
              this.employerData = resdata.result.data.previousEmployers
              this.employerData.forEach((element:any) => {
                element.entityInfo = typeof element.entityInfo == 'string' ? JSON.parse(element.entityInfo) : element.entityInfo 
                element.entity_services = typeof element.entity_services == 'string' ? JSON.parse(element.entity_services) : element.entity_services 
                element.entityInfo.default_image = typeof element.entityInfo.default_image == 'string' ? JSON.parse(element.entityInfo.default_image) : element.entityInfo.default_image 
              });
            }
          }
        }
        this.ls.showLoader = false
        this.isloader = false
      }
      if(resdata.responseType === SM_CONSTANTS.RESULT_API_GET_JOB_INVITATIONS){
        this.joiningInvitationsList = []
        this.employerData = []
        if(resdata.result){
          this.joiningInvitationsList = resdata.result;
          this.joiningInvitationsList.forEach((element: any) => {
            element.entityInfo =
              typeof element.entityInfo == "string"
                ? JSON.parse(element.entityInfo)
                : element.entityInfo;
          });
        }
        this.ls.showLoader = false;
        this.isloader = false
      }
    })
  }

  ngOnInit(): void {
    this.isloader = true
    this.ls.showLoader = true
    this.apiservice.getEmployerList()
  }


  selectChip(value:any){
    this.isloader = true
    this.ls.showLoader = true
    this.selectedValue = value
    
    if(this.selectedValue == 1 || this.selectedValue == 2){
      
      this.apiservice.getEmployerList()
    }
    else{
      this.apiservice.getJobInvitations(localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)!,localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_COUNTRY_CODE), localStorage.getItem(SM_CONSTANTS.KEY_NEW_ACCOUNT_PHONE_NUMBER),'0')

    }
  }

  openBusinessDetails(item:any){
    if(this.selectedValue == 1){
      if(!item.subscriptionInfo || item.subscriptionInfo == undefined || item.subscriptionInfo == '' || item.subscriptionInfo == 'null'){
             const dialogRef = this.dialog.open(CustomConfirmDialogComponent,{
                 width: '500px',
                 data : {
                   title : 'Access denied!',
                   message : 'The paid pack is expired for this business. You cannot access it right now. Ask your employer or owner of this business to recharge now.',
                   okbtn : 'Ok',
                   cancelbtn : 'Cancel',
                   type : SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE
                 },
                 disableClose : true
               });
           }
           else if(!item.employeeSubscriptionInfo || item.employeeSubscriptionInfo == undefined || item.employeeSubscriptionInfo == '' || item.employeeSubscriptionInfo == 'null'){
             const dialogRef = this.dialog.open(CustomConfirmDialogComponent,{
               width: '500px',
               data : {
                 title : 'Access denied!',
                 message : 'Your employee pack is either invalid or expired. You cannot access the business right now. Ask your employer or owner of this business to recharge now.',
                 okbtn : 'Ok',
                 cancelbtn : 'Cancel',
                 type : SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE
             },
               disableClose : true
             });
           }
             else if(!item.employee_status || item.employee_status != 1){
          const dialogRef = this.dialog.open(CustomConfirmDialogComponent,{
                    width: '500px',
                    data : {
                      title : 'Access denied!',
                      message : 'Your employer de-activated your access temporarily. You cannot perform any operation right now. Ask your employer or owner of this business to activate.',
                      okbtn : 'Ok',
                      cancelbtn : 'Cancel',
                      type : SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE
                  },
                    disableClose : true
                  });
                }
           else{
             localStorage.setItem(SM_CONSTANTS.CURRENT_ENTITY_HASH, item.hash_id);
             this.router.navigate(['/businesses/details'], {queryParams: {entityHash: item.hash_id}})
         
           }

    }
  }

  openInvitationsDetails(item:any){
    this.router.navigate(['/employees-profile/invitation-details'],{queryParams: {requestHash: item.requestHashId}})
  }

  opencontact(){
    this.router.navigate(['/contact-us']);
  }

}
